import { useTranslation } from "next-i18next"
import React from "react"
import { TFuncKey, TFunction } from "i18next"

type Props = {
    name: TFuncKey<"common">
    params?: Record<string, any>
}

export const Trans = (props: Props) => {
    const { t } = useTranslation("common")
    return <span>{t(props.name, props.params)}</span>
}

export const TransFn = ({ children }: { children: (t) => JSX.Element | string }) => {
    const { t } = useTranslation("common")
    return <>{children(t)}</>
}

export const useTrans = (): TransFnType => {
    const { t } = useTranslation("common")
    return t as TransFnType
}

type WithTransProps = {
    trans: TransFnType
}

export const withTrans = <T extends WithTransProps = WithTransProps>(WrappedComponent: React.ComponentType<T>) => {
    const displayName = WrappedComponent.displayName || WrappedComponent.name || "Component"

    const ComponentWithTheme = (props: Omit<T, keyof WithTransProps>) => {
        return <TransFn>{(trans) => <WrappedComponent trans={trans} {...(props as T)} />}</TransFn>
    }

    ComponentWithTheme.displayName = `withTrans(${displayName})`

    return ComponentWithTheme
}

export type TransFnType = TFunction<"common">
